// @flow

import type { State } from "@store/reducers";
import type { SpecialContactType } from "@modules/shared/reducer/special-contact-types/types";

export const getSpecialContactTypes = (state: State): Array<SpecialContactType> =>
  state.shared.specialContactTypes.list.content;
